(function() {
'use strict';

const TR = angular.module('TR');
TR.directive('radioButton', function($timeout) {
    return {
        restrict: 'E',
        replace: true,
        transclude: true,
        scope: {
            model: '=',
            val: '=',
            group: '@',
            property: '@',
            disabled: '=',
            onChange: '&'
        },
        templateUrl: 'partials/home/radiobutton',
        link(scope, el) {
            const chk = el.find('input');
            let val;

            function checked(c) {
                chk.prop('checked', c);
                if (c) {
                    el.addClass('checked');
                } else {
                    el.removeClass('checked');
                }
            }

            // Verifies if we're dealing with an object or a direct value
            function safeCheck(modelValue) {
                if (scope.property) {
                    checked(modelValue[scope.property] === val[scope.property]);
                } else {
                    checked(angular.equals(modelValue, val));
                }
            }

            const canc = scope.$watch('val', function(v) {
                if (v != null) {
                    val = scope.val;
                    safeCheck(scope.model);
                    canc();
                }
            });

            scope.$watch('model', function(v) {
                safeCheck(v);
                if (scope.onChange) {
                    scope.onChange();
                }
            });

            scope.toggle = function() {
                if (!scope.disabled) {
                    // Changes the model only if the value is new, emits the click
                    // event anyway.
                    const sameSelection = angular.equals(scope.model, val);
                    if (!sameSelection) {
                        scope.model = val;
                    }
                    $timeout(function() { scope.$emit('radio-clicked'); });
                }
            };
        }
    };
});
})();
